module.exports = __webpack_public_path__ + "static/BrandonGrotesque-Regular-8f947ced25922afabf23913cb4c2d860.woff";